var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Client } from '../client/Client';
import * as ServiceUtils from '../../services/utils';
import { FormikGenerator, TYPES } from '../../utils/FormikGenerator';
import { Stack, Card } from '@mui/material';
import { Typography } from '../../utils/Typography';
import { Button } from '../../utils/Button';
import * as ServiceClient from '../../services/client';
import { Loader } from '../../utils/Loader';
import { ConfirmDialog } from '../../utils/ConfirmDialog';
import { ExecIcon } from '../../utils/Icons';
var ACTIONS = {
    REMPLACER: 'Remplacer',
    AJOUTER: 'Ajouter',
    SUPPRIMER: 'Supprimer',
};
export var Reaffectation = function () {
    var _a = useState(false), loading = _a[0], setLoading = _a[1];
    var _b = useState([]), collaborateurs = _b[0], setCollaborateurs = _b[1];
    var _c = useState(null), filtres = _c[0], setFiltres = _c[1];
    var _d = useState([]), clientsSelected = _d[0], setClientsSelected = _d[1];
    useEffect(function () {
        var getData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var datas;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ServiceUtils.getSelectOptions('collaborateurs')];
                    case 1:
                        datas = _a.sent();
                        setCollaborateurs(datas);
                        return [2 /*return*/];
                }
            });
        }); };
        getData();
    }, []);
    var onChecked = function (checked, client) {
        var newClientsSelected = __spreadArray([], clientsSelected.filter(function (clientSelected) { return clientSelected.IdClient !== client.IdClient; }), true);
        if (checked) {
            newClientsSelected.push(client);
        }
        setClientsSelected(newClientsSelected);
    };
    var handleReaffectation = function () { return __awaiter(void 0, void 0, void 0, function () {
        var confirmation;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ConfirmDialog({
                        title: 'Confirmation',
                        content: 'Êtes vous sur de vouloir réaffecter ces clients ?',
                    })];
                case 1:
                    confirmation = _a.sent();
                    if (!confirmation.isOk) return [3 /*break*/, 3];
                    setLoading(true);
                    return [4 /*yield*/, ServiceClient.reaffectation({
                            CollaborateurIdDeleted: filtres.CollaborateurIdDeleted,
                            CollaborateurIdAdded: filtres.CollaborateurIdAdded,
                            ClientIds: clientsSelected.map(function (client) { return client.IdClient; }),
                        })];
                case 2:
                    _a.sent();
                    setFiltres(null);
                    setClientsSelected([]);
                    setLoading(false);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    if (loading) {
        return _jsx(Loader, {});
    }
    return (_jsxs(Stack, __assign({ p: 4 }, { children: [_jsx(FormikGenerator, { datas: {
                    Action: null,
                    CollaborateurIdDeleted: null,
                    CollaborateurIdAdded: null,
                }, validate: function () {
                    setFiltres(null);
                    setClientsSelected([]);
                }, renderContent: function (_a) {
                    var values = _a.values;
                    return (_jsxs(Stack, __assign({ pt: 1 }, { children: [values.Action === ACTIONS.AJOUTER && (_jsx(Typography, __assign({ color: "error" }, { children: "On ne peut ajouter un collaborateur que s'il n'est pas d\u00E9j\u00E0 dans l'\u00E9quipe client" }))), values.Action === ACTIONS.SUPPRIMER && (_jsx(Typography, __assign({ color: "error" }, { children: "On ne peut supprimer un collaborateur que s'il n'est pas dans une affaire en cours" }))), values.Action === ACTIONS.REMPLACER && (_jsx(Typography, __assign({ color: "error" }, { children: "Remplacer un collaborateur r\u00E9attribue les affaires en cours ainsi que les offres sur lesquels le remplac\u00E9 est positionn\u00E9" })))] })));
                }, onSubmit: function (_a) {
                    var Action = _a.Action, CollaborateurIdDeleted = _a.CollaborateurIdDeleted, CollaborateurIdAdded = _a.CollaborateurIdAdded;
                    return __awaiter(void 0, void 0, void 0, function () {
                        var params;
                        return __generator(this, function (_b) {
                            params = {};
                            if ([ACTIONS.SUPPRIMER, ACTIONS.REMPLACER].includes(Action)) {
                                params.CollaborateurIdDeleted = CollaborateurIdDeleted;
                            }
                            if ([ACTIONS.AJOUTER, ACTIONS.REMPLACER].includes(Action)) {
                                params.CollaborateurIdAdded = CollaborateurIdAdded;
                            }
                            setFiltres(params);
                            return [2 /*return*/];
                        });
                    });
                }, submitLabel: "Charger la liste", submitIcon: ExecIcon, fields: [
                    [
                        {
                            xs: 4,
                            label: 'Action',
                            name: 'Action',
                            type: TYPES.SELECT,
                            options: [
                                { label: ACTIONS.AJOUTER, value: ACTIONS.AJOUTER },
                                { label: ACTIONS.SUPPRIMER, value: ACTIONS.SUPPRIMER },
                                { label: ACTIONS.REMPLACER, value: ACTIONS.REMPLACER },
                            ],
                        },
                        {
                            xs: 4,
                            label: 'Supprimer le collaborateur',
                            name: 'CollaborateurIdDeleted',
                            type: TYPES.SELECT,
                            options: collaborateurs,
                            show: function (values) {
                                return [ACTIONS.SUPPRIMER, ACTIONS.REMPLACER].includes(values.Action);
                            },
                        },
                        {
                            xs: 4,
                            label: 'Ajouter le collaborateur',
                            name: 'CollaborateurIdAdded',
                            type: TYPES.SELECT,
                            options: collaborateurs,
                            show: function (values) {
                                return [ACTIONS.AJOUTER, ACTIONS.REMPLACER].includes(values.Action);
                            },
                        },
                    ],
                ] }), filtres && (_jsx(Card, __assign({ variant: "outlined" }, { children: _jsx(Client, { withFiltre: true, forceFiltres: filtres, onChecked: onChecked }) }))), _jsx(Stack, __assign({ spacing: 2 }, { children: clientsSelected.length ? (_jsxs(_Fragment, { children: [_jsxs(Typography, { children: [clientsSelected.length, " client(s) s\u00E9lectionn\u00E9(s)"] }), _jsx(Button, __assign({ color: "primary", onClick: handleReaffectation }, { children: "Valider" }))] })) : (_jsx(_Fragment, {})) }))] })));
};
//# sourceMappingURL=Reaffectation.js.map